import SuperLightboxView from "views/super_lightbox_view"
import CalendarDateRangePickerView from "views/calendar_date_range_picker_view"

export default class DateSelectLightboxView extends SuperLightboxView {
  initialize(options) {
    super.initialize(options)
    this.dateRangePicker = new CalendarDateRangePickerView({ ranges: [] })
    this.dateRangePicker.$el.appendTo(this.$el.find(".lightbox-inner"))

    this.listenTo(this.dateRangePicker, "cancel_date_pick", this._cancel)
    return this.listenTo(this.dateRangePicker, "update_date_range", this._update)
  }

  _cancel() {
    this.trigger("cancel")
    return this.close()
  }

  _update(start, end) {
    this.trigger("update", start, end)
    return this.close()
  }
}
